import { msg } from "@lingui/core/macro";

export const maxVehiclesOnPermitRuleMessages = {
	name: msg({ message: "Maximum Vehicles per Permit" }),
	description: msg({ message: "The maximum amount of vehicles a permit may contain" }),
	errors: {
		limitReached: msg({
			message:
				"This Permit has reached its maximum number of vehicles ({maxVehicleCount}). Delete or update an existing plate.",
		}),
	},
} as const;
